import React, { useState, useEffect } from "react";
import authService from "../../services/AuthorizeService";
import Constants from "../../helpers/Constants";

const LoginMenu = () => {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    authService.getUser().then((response) => {
      if (response) {
        setUserName(response.name!);
      }
    });
  }, []);

  return userName !== "" ? (
    <>
      <div className="signout-container">
        <a href={Constants.ApplicationPaths.Profile}>Hello {userName}</a>
      </div>
      <div className="signout-container">
        <a href={Constants.ApplicationPaths.LogOut}>Logout</a>
      </div>
    </>
  ) : (
    <div className="signout-container">
      <a href={Constants.ApplicationPaths.Login}>Login</a>
    </div>
  );
};

export default LoginMenu;
